import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Container,
  ProductInformation,
  CloudWrapper,
  Update,
} from 'styles/pages/edit-products/editProductInformation';
import Tooltip from '@material-ui/core/Tooltip';
import { DialogTitle } from 'styles/pages/edit-products/editProductDialog';
import Button from 'components/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from 'components/TextField';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import LogoImage from 'assets/images/logo.png';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const isImageValid = (url) =>
  url?.includes('.png') || url?.includes('.jpeg') || url?.includes('.jpg');

const openCloudinaryWidget = (folder, cb) => {
  const myWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: 'big-oven-tees-inc',
      uploadPreset: 'tnedst8q',
      folder,
    },
    (error, result) => {
      if (!error && result && result.event === 'success') {
        cb(result?.info?.secure_url);
        myWidget.close();
      }
    }
  );
  myWidget.open();
};

const EditPrintAreas = ({ product, updatePrintArea }) => {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    const tempArea = product?.PrintAreas || [];

    if (!tempArea?.length) {
      if (product?.Product?.MarketingImagePath) {
        tempArea.push({
          printAreaName: 'Front',
          printAreaMarketingImage: product?.Product?.MarketingImagePath,
          editable: true,
          designerSettings: product?.DesignerSettings || {},
        });
      }

      if (product?.Product?.MarketingBackImagePath) {
        tempArea.push({
          printAreaName: 'Back',
          printAreaMarketingImage: product?.Product?.MarketingBackImagePath,
          editable: true,
          designerSettings: product?.BackDesignerSettings || {},
        });
      }
    }

    setAreas(tempArea);
  }, []);

  const disabled = !!areas?.filter(
    (a) => !a?.printAreaName || !a?.printAreaMarketingImage
  )?.length;

  return (
    <Container style={{ border: 'none' }}>
      <DialogTitle style={{ padding: '0 0 10px 0', margin: 0, fontSize: 20 }}>
        Print Areas
        <Tooltip title="Add Print Area">
          <AddCircleIcon
            onClick={() =>
              setAreas([
                ...areas,
                {
                  editable: true,
                  printAreaName: '',
                  printAreaMarketingImage: '',
                  designerSettings: {},
                },
              ])
            }
            style={{
              float: 'right',
              cursor: 'pointer',
              color: '#000',
              fontSize: 30,
            }}
          />
        </Tooltip>
      </DialogTitle>

      <ProductInformation>
        {areas?.map((area, i) => {
          return (
            <div
              key={`EditPrintArea${i}`}
              style={{
                display: 'grid',
                margin: '30px 0px 0px 0px',
                gridGap: '20px',
                gridTemplateColumns:
                  product?.Product?.DecorationNeeded === false
                    ? '1fr 1fr 1fr 0fr'
                    : '1fr 1fr 0fr',
              }}
            >
              <TextField
                label="Area Name"
                size="small"
                value={area?.printAreaName}
                disabled={!area?.editable}
                onChange={(printAreaName) =>
                  setAreas(
                    areas?.map((a, j) => {
                      if (i !== j) {
                        return a;
                      }
                      return {
                        ...a,
                        printAreaName,
                      };
                    })
                  )
                }
              />
              <CloudWrapper>
                <img
                  src={
                    isImageValid(area?.printAreaMarketingImage)
                      ? area?.printAreaMarketingImage
                      : LogoImage
                  }
                />
                <TextField
                  label="Area Marketing Image"
                  size="small"
                  // disabled={true}
                  value={area?.printAreaMarketingImage}
                  onChange={(printAreaMarketingImage) =>
                    setAreas(
                      areas?.map((a, j) => {
                        if (i !== j) {
                          return a;
                        }
                        return {
                          ...a,
                          printAreaMarketingImage,
                        };
                      })
                    )
                  }
                />

                {/* {area?.editable && ( */}
                <CloudUploadIcon
                  onClick={() => {
                    openCloudinaryWidget(
                      `Shirtly/Shirtly_Products_Mock/Images/mockups/${product?.Product?.Name}`,
                      (printAreaMarketingImage) =>
                        setAreas(
                          areas?.map((a, j) => {
                            if (i !== j) {
                              return a;
                            }
                            return {
                              ...a,
                              printAreaMarketingImage,
                            };
                          })
                        )
                    );
                  }}
                />
                {/* )} */}
              </CloudWrapper>

              {product?.Product?.DecorationNeeded === false && (
                <CloudWrapper>
                  <img
                    src={
                      isImageValid(area?.productArtFile)
                        ? area?.productArtFile
                        : LogoImage
                    }
                  />
                  <TextField
                    label="Area Marketing Image"
                    size="small"
                    // disabled={true}
                    value={area?.productArtFile || ''}
                    onChange={(productArtFile) =>
                      setAreas(
                        areas?.map((a, j) => {
                          if (i !== j) {
                            return a;
                          }
                          return {
                            ...a,
                            productArtFile,
                          };
                        })
                      )
                    }
                  />

                  <CloudUploadIcon
                    onClick={() => {
                      openCloudinaryWidget(
                        `Shirtly/Shirtly_Products_Mock/Images/mockups/${product?.Product?.Name}/Artfiles`,
                        (productArtFile) =>
                          setAreas(
                            areas?.map((a, j) => {
                              if (i !== j) {
                                return a;
                              }
                              return {
                                ...a,
                                productArtFile,
                              };
                            })
                          )
                      );
                    }}
                  />
                </CloudWrapper>
              )}

              <DeleteIcon
                style={{
                  color: 'red',
                  cursor: 'pointer',
                  opacity: area?.editable ? 1 : 0.5,
                }}
                onClick={() => {
                  if (area.editable) {
                    const newAreas = areas?.filter((a, j) => i !== j);
                    setAreas(newAreas);
                  }
                }}
              />
            </div>
          );
        })}
        <Update style={{ margin: '30px 0 0 0' }}>
          <Button
            title="Update"
            disabled={disabled}
            onClick={() => {
              let additionalTechArtSettings = _.clone(
                product?.AdditionalTechniquesArtSettings
              );

              if (additionalTechArtSettings?.length > 0) {
                for (let i = 0; i < additionalTechArtSettings?.length; i++) {
                  let artSettings = [];
                  for (let j = 0; j < areas?.length; j++) {
                    artSettings.push({
                      areaName: areas[j].printAreaName,
                      areaSettings: areas[j].designerSettings,
                      image: areas[j].printAreaMarketingImage,
                    });
                  }
                  additionalTechArtSettings[i].artSettings = artSettings;
                }
              }

              updatePrintArea(areas, additionalTechArtSettings);
            }}
          />
        </Update>
      </ProductInformation>
    </Container>
  );
};

export default EditPrintAreas;
